import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import axios from "axios";
import { t } from "../../lang/index"

interface TrendingPacote {
    pacote: PacoteDTO;
    mediaAvaliacoes: number;
    totalCompras: number;
    score: number;
}
type PacoteDTO = {
    id: number;
    titulo: string;
    descricao: string;
    precoBase: number;
    fotoUrls: string[];
    idiomas?: string[];
    diferenciais?: DiferencialDTO[];
    servicoId: number;     // 🔹 novo
    servicoNome: string;   // 🔹 novo
};

type DiferencialDTO = {
    id: number;
    tipo: string;
    descricaoCustomizada?: string;
    quantidade?: number;
};

const TrendingPackages = () => {
    const routes = all_routes;
    const BASE_URL = process.env.REACT_APP_API_URL;

    const [pacotes, setPacotesLocal] = useState<TrendingPacote[]>([]);
    const [servicos, setServicos] = useState<{ id: number; nome: string }[]>([]);
    const [selectedServico, setSelectedServico] = useState<number | null>(null);
    const [selectedItems, setSelectedItems] = useState<boolean[]>([]);
    const [resumos, setResumos] = useState<Record<number, { media: number; total: number }>>({});

    const place = t("home.placeSection") as any;

    // função para embaralhar array (Fisher–Yates shuffle)
    const shuffleArray = <T,>(array: T[]): T[] => {
        const shuffled = [...array];
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled;
    };

    useEffect(() => {
        const fetchPacotes = async () => {
            try {
                const res = await axios.get(`${BASE_URL}/pacotes/trending?limit=20`);
                const data: TrendingPacote[] = res.data;

                // 🔹 extrair serviços distintos de todos os pacotes
                const uniqueServicos = Array.from(
                    new Map(
                        data.map((p) => ({ id: p.pacote.servicoId, nome: p.pacote.servicoNome }))
                            .map((item) => [item.id, item])
                    ).values()
                ).sort((a, b) => a.nome.localeCompare(b.nome));

                setServicos(uniqueServicos);

                // 🔹 inicializa pacotes exibidos (embaralhar + limitar 4)
                setPacotesLocal(shuffleArray(data).slice(0, 4));
                setSelectedItems(new Array(Math.min(data.length, 4)).fill(false));
            } catch (err) {
                console.error("Erro ao buscar pacotes trending", err);
            }
        };

        fetchPacotes();
    }, [BASE_URL]);

    // buscar resumos por pacote
    useEffect(() => {
        const fetchResumos = async () => {
            if (pacotes.length === 0) return;

            try {
                const responses = await Promise.all(
                    pacotes.map((p) =>
                        axios.get(`${BASE_URL}/avaliacoes/pacote/${p.pacote.id}/resumo`).then((res) => res.data)
                    )
                );

                const map: Record<number, { media: number; total: number }> = {};
                pacotes.forEach((p, idx) => {
                    map[p.pacote.id!] = responses[idx];
                });

                setResumos(map);
            } catch (err) {
                console.error("Erro ao buscar resumos:", err);
            }
        };

        fetchResumos();
    }, [pacotes, BASE_URL]);

    const handleItemClick = (index: number) => {
        const updated = [...selectedItems];
        updated[index] = !updated[index];
        setSelectedItems(updated);
    };

    // filtrar pacotes pelo serviço selecionado e limitar a 4 pacotes embaralhados
    const filteredPacotes = (() => {
        let temp = selectedServico
            ? pacotes.filter((p) => p.pacote.servicoId === selectedServico)
            : pacotes;

        // embaralhar e pegar até 4 pacotes
        return shuffleArray(temp).slice(0, 4);
    })();


    return (
        <section className="section place-section bg-white">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-6 col-lg-10 text-center">
                        <div className="section-header mb-4">
                            <h2 className="mb-2">
                                {place.titlePrefix} <span className="text-primary text-decoration-underline">{place.titleHighlight}</span>
                            </h2>
                            <p className="sub-title">{place.subtitle}</p>
                        </div>
                    </div>
                </div>

                {/* Filtro por serviço */}
                <div className="place-nav">
                    <ul className="nav justify-content-center">
                        <li>
                            <Link
                                to="#"
                                className={`nav-link ${selectedServico === null ? "active" : ""}`}
                                onClick={() => setSelectedServico(null)}
                            >
                                {place.all}
                            </Link>
                        </li>
                        {servicos.map((s) => (
                            <li key={s.id}>
                                <Link
                                    to="#"
                                    className={`nav-link ${selectedServico === s.id ? "active" : ""}`}
                                    onClick={() => setSelectedServico(s.id)}
                                >
                                    {s.nome}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Cards */}
                <div className="row">
                    {filteredPacotes.map((p, index) => {
                        const fotoPrincipal =
                            p.pacote.fotoUrls && p.pacote.fotoUrls.length > 0
                                ? p.pacote.fotoUrls[0]
                                : "assets/img/flight/flight-09.jpg";

                        const finalUrl = fotoPrincipal.startsWith("http")
                            ? fotoPrincipal
                            : `${BASE_URL}${fotoPrincipal}`;

                        return (
                            <div className="col-10 col-md-6 col-lg-3 d-flex" key={p.pacote.id || index}>
                                <div className="place-item common-grid-slider mb-4 flex-fill d-flex flex-column" style={{ fontSize: "0.9rem", minHeight: "320px" }}>
                                    <div className="place-img">
                                        <Link to={`/flight-details/${p.pacote.id}`}>
                                            <img src={finalUrl} className="img-fluid" alt={p.pacote.titulo} style={{ height: "180px", objectFit: "cover", borderRadius: "8px" }} />
                                        </Link>

                                        <div className="fav-item" onClick={() => handleItemClick(index)}>
                                            <div className="d-flex align-items-center">
                                                <Link to="#" className={`fav-icon ${selectedItems[index] ? "selected" : ""}`}>
                                                    <i className="isax isax-heart5"></i>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="place-content d-flex flex-column" style={{ fontSize: "0.9rem", flexGrow: 1 }}>
                                        <div className="d-flex flex-column" style={{ gap: "0.25rem" }}>
                                            <h6 className="text-truncate mb-0">
                                                <Link to={`/flight-details/${p.pacote.id}`}>{p.pacote.titulo}</Link>
                                            </h6>

                                            {p.pacote.diferenciais && p.pacote.diferenciais.length > 0 && (
                                                <span className="badge fs-10 fw-medium d-flex align-items-center" style={{ backgroundColor: "#cfe2ff", color: "#0d6efd", padding: "0.2rem 0.4rem", borderRadius: "6px", display: "inline-flex", fontSize: "0.7rem" }}>
                                                    <i className="isax isax-star5 me-1"></i> {place.hasDiferencial}
                                                </span>
                                            )}
                                        </div>

                                        <div className="d-flex align-items-center justify-content-between border-top pt-2 mt-auto">
                                            <div className="d-flex align-items-center">
                                                <h6 className="text-primary m-0 me-2" style={{ fontSize: "0.9rem" }}>
                                                    $ {p.pacote.precoBase?.toFixed(2)}
                                                </h6>

                                                {resumos[p.pacote.id!] ? (
                                                    resumos[p.pacote.id!].total > 0 ? (
                                                        <div className="d-flex align-items-center">
                                                            <i className="isax isax-star1 text-warning me-1 fs-14" />
                                                            <span className="badge badge-warning badge-xs text-gray-9 fs-10 fw-medium me-1 p-1">
                                                                <i className="isax isax-star" />
                                                                {resumos[p.pacote.id!].media.toFixed(1)}
                                                            </span>
                                                            <small className="text-muted">({resumos[p.pacote.id!].total})</small>
                                                        </div>
                                                    ) : (
                                                        <small className="text-muted">{place.noReviews}</small>
                                                    )
                                                ) : null}
                                            </div>

                                            <div className="d-flex align-items-center flex-wrap">
                                                {p.pacote.idiomas && p.pacote.idiomas.length > 0 && (
                                                    <>
                                                        {p.pacote.idiomas.slice(0, 2).map((idioma, i) => (
                                                            <span key={i} className="badge bg-outline-success fs-10 fw-medium me-1 mb-1">
                                                                {idioma}
                                                            </span>
                                                        ))}
                                                        {p.pacote.idiomas.length > 2 && (
                                                            <span className="badge bg-outline-success fs-10 fw-medium mb-1">
                                                                +{p.pacote.idiomas.length - 2} more
                                                            </span>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="text-center view-all">
                    <Link to={routes.flightGrid} className="btn btn-dark d-inline-flex align-items-center">
                        {place.viewAll}<i className="isax isax-arrow-right-3 ms-2"></i>
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default TrendingPackages;